module.exports = __webpack_public_path__ + "static/media/bo.d3b9a08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bo.png
// module id = 1803
// module chunks = 0